<template>
    <div v-if="hasCritical || hasDismissible" class="mb-5">
        <div v-if="hasCritical">
            <warning-or-message
                    v-for="item in critical"
                    :key="item.code"
                    v-bind:code="item.code"
                    v-bind:message="item.message"
                    critical />
        </div>
        <div v-if="hasDismissible" >
            <warning-or-message
                    v-for="item in dismissible"
                    :key="item.code"
                    v-bind:code="item.code"
                    v-bind:message="item.message"/>
        </div>
    </div>
</template>

<script>
    import WarningOrMessage from './WarningOrMessage'
    import messages from "@/util/messages";
    export default {
        name: "MessageView",
        components: {
            WarningOrMessage
        },
        data() {
            return {
                critical: [],
                dismissible: []
            };
        },
        computed: {
            hasCritical() {
                return this.critical.length > 0
            },
            hasDismissible() {
                return this.dismissible.length > 0
            }
        },
        mounted() {
            this.$set(this, 'critical', messages.critical)
            this.$set(this, 'dismissible', messages.dismissible)
        }
    }
</script>

<style scoped>

</style>